var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from 'react';
import { Formik } from 'formik';
import { useStore } from 'react-context-hook';
import { BsLock } from 'react-icons/bs';
import { useParams } from 'react-router-dom';
import * as yup from 'yup';
import { useFlashMessage } from '@app/components/obj.flash-message';
import { axiosClient } from '@app/configure-app';
import { ExternalQuestionnaireComponent } from '@app/modules/questionnarie/external/external-questionnaire.component';
import { getUserLocation } from '@app/services/location';
import { convertFileToBase64 } from '@app/utils/shared-functions.utils';
import { FlashMessageEnum } from '@atomic';
import { AcoesStyled, FormularioStyled, RodapeStyled } from '../components/nps-bloco';
import { NpsBotao } from '../components/nps-botao';
import { NpsCabecalho } from '../components/nps-cabecalho';
import { NpsComentario } from '../components/nps-comentario';
import { NpsContato, NpsFraseConsentimento } from '../components/nps-contato';
import { NpsEscala } from '../components/nps-escala';
import { NpsLinkUnidade } from '../components/nps-link-unidade';
import { NpsObrigado } from '../components/nps-obrigado';
import { NpsPromotor } from '../components/nps-promotor';
import { NpsRepescagem } from '../components/nps-repescagem';
import { NpsTelaFolha } from '../components/nps-tela';
import { ESQUEMA_CONTATO, MENSAGEM_ERRO_ENVIO, MENSAGEM_ERRO_FOTO, NPS_CONSENTIMENTO_CHECKBOX, POST_NPS_URL, TEXTOS_DO_GRUPO, } from '../nps.constants';
import { copiarTexto, grupoDaNota, primeiroNome, textoObrigado } from '../nps.utils';
import { ConfirmationModal } from './confirmation-modal.tsx/confirmation-modal';
import { HiddenFileInput } from './styles';
export var NPS = function (_a) {
    var _b, _c, _d, _e, _f;
    var logo = _a.logo, unidadeEmpresa = _a.unidadeEmpresa;
    var company = useStore('company')[0];
    var id = useParams().id;
    var _g = React.useState(null), nota = _g[0], setNota = _g[1];
    var _h = React.useState(''), comment = _h[0], setComment = _h[1];
    var _j = React.useState(false), isUserInfoFilled = _j[0], setUserInfoFilled = _j[1];
    var _k = React.useState(undefined), coordenadas = _k[0], setCoordenadas = _k[1];
    var _l = React.useState(undefined), userAgent = _l[0], setUserAgent = _l[1];
    var _m = React.useState(undefined), file = _m[0], setFile = _m[1];
    var _o = React.useState(''), nomeFoto = _o[0], setNomeFoto = _o[1];
    var _p = React.useState(null), fileBase64 = _p[0], setFileBase64 = _p[1];
    var _q = React.useState(true), lgpd = _q[0], setLgpd = _q[1];
    var _r = React.useState(undefined), npsId = _r[0], setNpsId = _r[1];
    var _s = React.useState(false), isLoading = _s[0], setIsLoading = _s[1];
    var showFlashMessage = useFlashMessage()[0];
    // Etapas do novo fluxo (Tela 1 -> 2a/2b -> 3). Os dados ficam aqui porque o questionário desmonta o Formik.
    var _t = React.useState('avaliacao'), etapa = _t[0], setEtapa = _t[1];
    var _u = React.useState(false), copiou = _u[0], setCopiou = _u[1];
    var _v = React.useState(''), nomeInformado = _v[0], setNomeInformado = _v[1];
    var _w = React.useState(false), temContato = _w[0], setTemContato = _w[1];
    var enviandoRef = React.useRef(false);
    var copiaRef = React.useRef(Promise.resolve(false));
    var _x = React.useState(false), showConfirmationModal = _x[0], setShowConfirmationModal = _x[1];
    var _y = React.useState(null), questionarioParaNota = _y[0], setQuestionarioParaNota = _y[1];
    var _z = React.useState(false), showQuestionario = _z[0], setShowQuestionario = _z[1];
    var fileInputRef = React.useRef(null);
    // A foto só pode ir no envio depois de convertida; o contador descarta conversões de fotos trocadas ou removidas.
    var _0 = React.useState(false), convertendoFoto = _0[0], setConvertendoFoto = _0[1];
    var conversaoFotoRef = React.useRef(0);
    // fantasia é opcional no cadastro da empresa: sem ela, usa o nome (mesma regra de modal-pdf.tsx).
    var empresa = ((_b = company === null || company === void 0 ? void 0 : company.fantasia) === null || _b === void 0 ? void 0 : _b.trim()) || ((_c = company === null || company === void 0 ? void 0 : company.nome) === null || _c === void 0 ? void 0 : _c.trim()) || '';
    // A página resolve a logo: a da unidade, se cadastrada no Admin, senão a da empresa (esta também enquanto carrega).
    var logoMarca = logo || (company === null || company === void 0 ? void 0 : company.imgLogo);
    var urlGoogle = unidadeEmpresa === null || unidadeEmpresa === void 0 ? void 0 : unidadeEmpresa.urlGoogleBusiness;
    var grupo = nota === null ? null : grupoDaNota(nota);
    var handleDeleteImageClick = function () {
        conversaoFotoRef.current += 1;
        setConvertendoFoto(false);
        setFileBase64(null);
        setFile(undefined);
        setNomeFoto('');
        // A conversão pode falhar depois de a tela sair; aí o input já não existe.
        if (fileInputRef.current)
            fileInputRef.current.value = '';
    };
    var handleImageChange = function (event) { return __awaiter(void 0, void 0, void 0, function () {
        var arquivo, conversao, base64, error_1;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    arquivo = (_a = event.target.files) === null || _a === void 0 ? void 0 : _a[0];
                    if (!arquivo)
                        return [2 /*return*/];
                    conversaoFotoRef.current += 1;
                    conversao = conversaoFotoRef.current;
                    setFile(URL.createObjectURL(arquivo));
                    setNomeFoto(arquivo.name);
                    setFileBase64(null);
                    setConvertendoFoto(true);
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, convertFileToBase64(arquivo)];
                case 2:
                    base64 = _b.sent();
                    if (conversao === conversaoFotoRef.current)
                        setFileBase64(base64);
                    return [3 /*break*/, 5];
                case 3:
                    error_1 = _b.sent();
                    console.error('Erro ao converter a foto:', error_1);
                    if (conversao === conversaoFotoRef.current) {
                        handleDeleteImageClick();
                        showFlashMessage(FlashMessageEnum.alert, MENSAGEM_ERRO_FOTO);
                    }
                    return [3 /*break*/, 5];
                case 4:
                    if (conversao === conversaoFotoRef.current)
                        setConvertendoFoto(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    var handleAddImageClick = function () {
        var _a;
        (_a = fileInputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    };
    React.useEffect(function () {
        setUserAgent(window.navigator.userAgent);
        var getLocation = function () { return __awaiter(void 0, void 0, void 0, function () {
            var userCoordenadas, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getUserLocation()];
                    case 1:
                        userCoordenadas = _a.sent();
                        setCoordenadas(userCoordenadas);
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        console.error('Error fetching user location:', error_2);
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        getLocation();
    }, []);
    // Ao sair da tela, descarta a conversão de foto pendente (nenhum contador válido é negativo).
    React.useEffect(function () { return function () {
        conversaoFotoRef.current = -1;
    }; }, []);
    // Decide a tela seguinte pelo grupo da nota (RF-02).
    var seguirFluxoNovo = function (comContato) {
        if (comContato === void 0) { comContato = temContato; }
        if (grupo === 'promotor') {
            setEtapa(urlGoogle ? 'promotor' : 'obrigado');
        }
        else if (grupo === 'detrator' && !comContato) {
            setEtapa('repescagem');
        }
        else {
            setEtapa('obrigado');
        }
    };
    // A cópia precisa acontecer dentro do toque; o Safari bloqueia depois do await do envio (DT-01).
    var handleClickEnviar = function () {
        var textoParaCopiar = comment.trim();
        copiaRef.current =
            grupo === 'promotor' && urlGoogle && textoParaCopiar ? copiarTexto(textoParaCopiar) : Promise.resolve(false);
    };
    var handleSubmit = function (formValues) { return __awaiter(void 0, void 0, void 0, function () {
        var contato, response, _a, questionariosConfig, questionarioEncontrado, error_3;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (enviandoRef.current || isLoading || convertendoFoto)
                        return [2 /*return*/];
                    enviandoRef.current = true;
                    setIsLoading(true);
                    contato = isUserInfoFilled ? formValues : { nome: '', email: '', telefone: '' };
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 4, 5, 6]);
                    return [4 /*yield*/, axiosClient.post(POST_NPS_URL + "/" + id, {
                            nota: nota,
                            comentario: comment,
                            clienteNome: contato.nome,
                            clienteEmail: contato.email,
                            clienteTelefone: contato.telefone,
                            lgpb: lgpd,
                            coordenadas: coordenadas,
                            userAgent: userAgent,
                            imagem: fileBase64,
                            unidadeEmpresaToken: localStorage.getItem('npsToken'),
                        })];
                case 2:
                    response = _b.sent();
                    localStorage.setItem('npsToken', unidadeEmpresa === null || unidadeEmpresa === void 0 ? void 0 : unidadeEmpresa.token);
                    setNpsId(response.data.data);
                    _a = setCopiou;
                    return [4 /*yield*/, copiaRef.current];
                case 3:
                    _a.apply(void 0, [_b.sent()]);
                    setNomeInformado(contato.nome);
                    setTemContato(isUserInfoFilled);
                    questionariosConfig = (unidadeEmpresa === null || unidadeEmpresa === void 0 ? void 0 : unidadeEmpresa.questionarioEmpresaConfiguracaoNps) || [];
                    questionarioEncontrado = questionariosConfig.find(function (q) { return q.nota === nota; });
                    if (questionarioEncontrado) {
                        // MOSTRAR POPUP DE CONFIRMAÇÃO
                        setQuestionarioParaNota(questionarioEncontrado);
                        setShowConfirmationModal(true);
                    }
                    else {
                        seguirFluxoNovo(isUserInfoFilled);
                    }
                    return [3 /*break*/, 6];
                case 4:
                    error_3 = _b.sent();
                    console.error('Submission failed:', error_3);
                    localStorage.removeItem('npsToken');
                    showFlashMessage(FlashMessageEnum.alert, MENSAGEM_ERRO_ENVIO);
                    return [3 /*break*/, 6];
                case 5:
                    enviandoRef.current = false;
                    setIsLoading(false);
                    return [7 /*endfinally*/];
                case 6: return [2 /*return*/];
            }
        });
    }); };
    // FUNÇÃO QUANDO USUÁRIO CONFIRMA RESPONDER QUESTIONÁRIO
    var handleConfirmQuestionario = function () {
        setShowConfirmationModal(false);
        setShowQuestionario(true);
    };
    // FUNÇÃO QUANDO USUÁRIO RECUSA QUESTIONÁRIO
    var handleCancelQuestionario = function () {
        setShowConfirmationModal(false);
        seguirFluxoNovo();
    };
    var handleContatoRepescagem = function (nome) {
        setNomeInformado(nome);
        setTemContato(true);
        setEtapa('obrigado');
    };
    var schema = isUserInfoFilled ? ESQUEMA_CONTATO : yup.string();
    // quando showQuestionario estiver true mostramos somente o componente externo
    if (showQuestionario) {
        // prioriza questionarioParaNota (definido quando usuário confirma responder),
        // senão busca pelo array de configuração usando a nota selecionada.
        var externalQuestionId = String((_d = questionarioParaNota === null || questionarioParaNota === void 0 ? void 0 : questionarioParaNota.questionarioEmpresaId) !== null && _d !== void 0 ? _d : (_f = (_e = unidadeEmpresa === null || unidadeEmpresa === void 0 ? void 0 : unidadeEmpresa.questionarioEmpresaConfiguracaoNps) === null || _e === void 0 ? void 0 : _e.find(function (q) { return q.nota === nota; })) === null || _f === void 0 ? void 0 : _f.questionarioEmpresaId);
        return (React.createElement(ExternalQuestionnaireComponent, { id: externalQuestionId, logo: logoMarca, nome: unidadeEmpresa === null || unidadeEmpresa === void 0 ? void 0 : unidadeEmpresa.nome, npsId: npsId, onComplete: function () {
                // esconder questionário e seguir o fluxo novo (2a, 2b ou Obrigado)
                setShowQuestionario(false);
                seguirFluxoNovo();
            }, onClose: function () {
                setShowQuestionario(false);
                seguirFluxoNovo();
            } }));
    }
    if (etapa === 'promotor') {
        return (React.createElement(NpsPromotor, { npsId: npsId, urlGoogle: urlGoogle, comentario: comment, copiou: copiou, onEncerrar: function () { return setEtapa('obrigado'); } }));
    }
    if (etapa === 'repescagem') {
        return (React.createElement(NpsRepescagem, { npsId: npsId, logo: logoMarca, empresa: empresa, unidade: unidadeEmpresa === null || unidadeEmpresa === void 0 ? void 0 : unidadeEmpresa.nome, onContatoEnviado: handleContatoRepescagem, onPreferirNaoInformar: function () { return setEtapa('obrigado'); } }));
    }
    if (etapa === 'obrigado') {
        var cenario = grupo === 'promotor' ? 'promotor' : 'neutro';
        if (grupo === 'detrator')
            cenario = temContato ? 'detratorComContato' : 'detratorSemContato';
        return (React.createElement(NpsObrigado, { primeiroNome: primeiroNome(nomeInformado), texto: textoObrigado(cenario, empresa !== null && empresa !== void 0 ? empresa : ''), logo: logoMarca, empresa: empresa }));
    }
    var textosDoGrupo = grupo ? TEXTOS_DO_GRUPO[grupo] : null;
    return (React.createElement(React.Fragment, null,
        React.createElement(ConfirmationModal, { open: showConfirmationModal, onConfirm: handleConfirmQuestionario, onCancel: handleCancelQuestionario }),
        React.createElement(HiddenFileInput, { ref: fileInputRef, type: "file", accept: "image/*", onChange: handleImageChange }),
        React.createElement(NpsTelaFolha, { topo: React.createElement(NpsCabecalho, { logo: logoMarca, empresa: empresa, unidade: unidadeEmpresa === null || unidadeEmpresa === void 0 ? void 0 : unidadeEmpresa.nome, titulo: "Como foi sua experi\u00EAncia hoje?", subtitulo: "De 0 a 10, quanto voc\u00EA nos recomendaria a um amigo?" }) },
            React.createElement(NpsLinkUnidade, { imagem: unidadeEmpresa === null || unidadeEmpresa === void 0 ? void 0 : unidadeEmpresa.imagemNpsUrl, titulo: unidadeEmpresa === null || unidadeEmpresa === void 0 ? void 0 : unidadeEmpresa.tituloNpsUrl, url: unidadeEmpresa === null || unidadeEmpresa === void 0 ? void 0 : unidadeEmpresa.npsUrl }),
            React.createElement(Formik, { initialValues: { nome: '', telefone: '', email: '' }, enableReinitialize: true, onSubmit: handleSubmit, validationSchema: schema }, function () { return (React.createElement(FormularioStyled, null,
                React.createElement(NpsEscala, { nota: nota, onEscolher: setNota }),
                textosDoGrupo && (React.createElement(React.Fragment, null,
                    React.createElement(NpsComentario, { rotulo: textosDoGrupo.rotuloComentario, placeholder: textosDoGrupo.apoioComentario, valor: comment, onAlterar: setComment, foto: file, nomeFoto: nomeFoto, onAdicionarFoto: handleAddImageClick, onRemoverFoto: handleDeleteImageClick }),
                    React.createElement(NpsContato, { interruptor: {
                            ligado: isUserInfoFilled,
                            subtitulo: textosDoGrupo.subtituloContato,
                            onAlternar: function () { return setUserInfoFilled(function (old) { return !old; }); },
                        }, consentimento: lgpd, onConsentimento: setLgpd }))),
                React.createElement(AcoesStyled, null,
                    React.createElement(NpsBotao, { variante: "primario", type: "submit", disabled: nota === null || isLoading || convertendoFoto, loading: isLoading, onClick: handleClickEnviar }, "Enviar avalia\u00E7\u00E3o")),
                isUserInfoFilled && nota !== null ? (!NPS_CONSENTIMENTO_CHECKBOX && (React.createElement(RodapeStyled, null,
                    React.createElement(NpsFraseConsentimento, null)))) : (React.createElement(RodapeStyled, null,
                    React.createElement(BsLock, { size: 12, "aria-hidden": "true" }),
                    "Sua opini\u00E3o \u00E9 an\u00F4nima e segura")))); }))));
};
